import React from "react";
import { RaisedButton } from "material-ui";
import { cloneDeep } from "lodash";
import TicketBucketEditor from "./ticket-bucket-editor.jsx";
import InfoNotice from "./info-notice.jsx";
import InjectedSelect from "./injected-select.jsx";
import Close from "material-ui/svg-icons/navigation/close";

class TicketBucketsEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCloneBucketSelector: false,
      selectedCloneEventId: null,
      clonedTicketBuckets: []
    };
  }

  onAdd(isFirst) {
    this.props.onAdd({
      event: this.props.event,
      name:
        isFirst &&
        (this.props.venueDetails
          ? !this.props.venueDetails.use_reserved_seating
          : true)
          ? this.props.eventDetails && this.props.eventDetails.is_virtual
            ? "Virtual Admission"
            : "General Admission"
          : "",
      quantity:
        isFirst && this.props.venueDetails
          ? this.props.venueDetails.default_capacity
          : "",
      price: "",
      variants: [],
      applicable_pass_buckets: [],
      public: true
    });
  }

  onCloneFromAnotherEventClick() {
    let updatedState = {
      showCloneBucketSelector: !this.state.showCloneBucketSelector
    };
    // when cancel is clicked
    if (this.state.showCloneBucketSelector === true) {
      //remove items from any unsaved cloned selection
      let delIndexes = [];
      for (let tb = this.state.clonedTicketBuckets.length - 1; tb >= 0; tb--) {
        const thisBucket = this.state.clonedTicketBuckets[tb];
        for (let x = this.props.ticketBuckets.length - 1; x >= 0; x--) {
          if (this.props.ticketBuckets[x].cloneId === thisBucket.cloneId) {
            delIndexes.push(x);
          }
        }
      }
      //delete all cloned items at one time, no additions
      if (delIndexes.length) {
        this.props.onAddAndDelete({
          additions: [],
          delIndexes: delIndexes
        });
      }
      updatedState.selectedCloneEventId = null;
      updatedState.clonedTicketBuckets = [];
    }
    this.setState(updatedState);
  }

  onCloneFromAnotherEventSelection(e) {
    //identify items from any previous unsaved cloned selection
    let delIndexes = [];
    for (let tb = this.state.clonedTicketBuckets.length - 1; tb >= 0; tb--) {
      const thisBucket = this.state.clonedTicketBuckets[tb];
      for (let x = this.props.ticketBuckets.length - 1; x >= 0; x--) {
        if (this.props.ticketBuckets[x].cloneId === thisBucket.cloneId) {
          delIndexes.push(x);
          break;
        }
      }
    }

    //clone e.ticket_buckets and clear out the ids for buckets and variants
    let clonedTicketBuckets = e.ticket_buckets.map(item => {
      let newItem = cloneDeep(item);
      newItem.cloneId = newItem.id;
      newItem.id = null;
      //clear variant ids if they exist
      if (newItem.variants && newItem.variants.length > 0) {
        for (let v = 0; v < newItem.variants.length; v++) {
          newItem.variants[v].id = null;
        }
      }
      return newItem;
    });

    //add new cloned items and delete unsaved cloned selections
    this.props.onAddAndDelete({
      additions: clonedTicketBuckets,
      delIndexes: delIndexes
    });

    //update state
    this.setState({
      selectedCloneEventId: e.id,
      clonedTicketBuckets: clonedTicketBuckets
    });
  }

  render() {
    return (
      <div>
        {this.props.venueDetails &&
        this.props.venueDetails.use_reserved_seating ? (
          <img
            src={this.props.venueDetails.seatmap_preview_image}
            style={{ float: "right", maxWidth: 200, maxHeight: 130 }}
          />
        ) : null}
        {this.props.eventDetails &&
        this.props.eventDetails.ticket_buckets &&
        !this.props.eventDetails.ticket_buckets.length ? (
          <div style={{ float: "right" }}>
            <div
              style={{
                height: 45,
                paddingLeft: 15,
                float: "right"
              }}
            >
              <RaisedButton
                key={this.state.showCloneBucketSelector ? "open" : "closed"}
                label={
                  this.state.showCloneBucketSelector
                    ? ""
                    : "Clone from Another Event"
                }
                icon={
                  this.state.showCloneBucketSelector ? (
                    <Close
                      style={{
                        paddingLeft: 10,
                        paddingRight: 10,
                        paddingTop: 8,
                        verticalAlign: 0,
                        width: 20,
                        height: 20
                      }}
                    />
                  ) : null
                }
                onTouchTap={e => this.onCloneFromAnotherEventClick(e)}
              />
            </div>
            {this.state.showCloneBucketSelector ? (
              <div
                style={{
                  height: 45,
                  minWidth: 300,
                  paddingLeft: 15,
                  float: "right"
                }}
              >
                <InjectedSelect
                  value={this.state.selectedCloneEventId}
                  types={["events"]}
                  placeholderText="Select an event to clone from..."
                  eventBucketId={this.props.eventDetails.event_bucket}
                  changeValueFunction={e => e}
                  closeOnSelect={true}
                  clearable={false}
                  searchable={true}
                  filterBy={o => {
                    return o.ticket_buckets.length > 0 ? true : false;
                  }}
                  labelFormatter={f => {
                    return `${f.name} (${f.ticket_buckets.length})`;
                  }}
                  onChange={e => {
                    this.onCloneFromAnotherEventSelection(e);
                  }}
                />
              </div>
            ) : null}
          </div>
        ) : null}
        <p>
          Add ticket buckets to the event. If no ticket buckets are added, the
          event will be listed as{" "}
          {this.props.eventDetails && this.props.eventDetails.is_virtual
            ? '"not currently available"'
            : 'a "non-ticketed event"'}
          .
          <InfoNotice style={{ marginTop: 5 }}>
            Check out our{" "}
            <a
              href="http://help.eventive.org/events-and-tickets/create-ticket-buckets"
              target="_blank"
            >
              guide to creating ticket buckets
            </a>
            .
          </InfoNotice>
        </p>
        <div style={{ clear: "both" }}>
          {this.props.ticketBuckets.map((bucket, i) => {
            return (
              <TicketBucketEditor
                key={bucket.id || i}
                bucket={bucket}
                eventDetails={this.props.eventDetails}
                index={i}
                onEdit={e => this.props.onEdit(i, e)}
                venueDetails={this.props.venueDetails}
                shiftPosition={e => this.props.onShiftPosition(i, e)}
                delete={e => this.props.onDelete(i)}
                canShiftUp={i > 0}
                canShiftDown={i < this.props.ticketBuckets.length - 1}
                hasMultipleTicketBuckets={this.props.ticketBuckets.length > 1}
                ticketBuckets={this.props.ticketBuckets}
              />
            );
          })}
          <RaisedButton
            label="Add new ticket bucket"
            onClick={e => this.onAdd(this.props.ticketBuckets.length === 0)}
          />
        </div>
      </div>
    );
  }
}

export default TicketBucketsEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-buckets-editor.jsx